import React from 'react'
//import { injectIntl, intlShape } from 'react-in'
import ReactRouterPropTypes from 'react-router-prop-types'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'

import { urls, pushHistoryWithErrorNotFound } from '../../../utils/routing'
import { formatShortDate } from '../../../utils/formatting'

import Back from '../../Buttons/Back/Back'
import Content from '../../Content/Content'
import Error from '../../Error/Error'
import Main from '../../Main/Main'
import TitleMajor from '../../TitleMajor/TitleMajor'

import {
    COMMON_ERROR,
    TO_LANDING,
} from '../../../translations'

import { documentTitle } from './translations'

import styles from './MediaPage.module.css'

class MediaPage extends React.Component {
    static propTypes = {
        data: PropTypes.shape({
            videoId: PropTypes.string,
            title: PropTypes.string,
            videoUrl: PropTypes.string,
            link: PropTypes.string,
            publishedAt: PropTypes.string,
        }).isRequired,
        title: PropTypes.string,

        isError: PropTypes.bool.isRequired,
        isErrorNotFound: PropTypes.bool.isRequired,
        isFetched: PropTypes.bool.isRequired,
        isFetching: PropTypes.bool.isRequired,

        history: ReactRouterPropTypes.history.isRequired,

        fetchMediaPage: PropTypes.func.isRequired,
    }

    componentDidMount() {
        this.props.fetchMediaPage(this.getSlug(this.props))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isErrorNotFound) {
            pushHistoryWithErrorNotFound(this.props.history)
        }
        
        if (this.props.location.state !== nextProps.location.state) { // this.props.match !== nextProps.match
            this.props.fetchMediaPage(this.getSlug(nextProps))
        }

        this.setDocumentTitle(nextProps)
    }

    setDocumentTitle(props) {
        if (props.data.title) {
            document.title = documentTitle(props.data.title) //this.props.intl.formatMessage(messages.documentTitle, { pageTitle: props.data.title })
        }
    }

    getSlug(props) {
        const slug = props.location.pathname.toString().slice(7).replace(/^\/|\/$/g, '');

        let index_url = slug.indexOf('/');
        let index_video = slug.slice(0, index_url);

        const slug_media = props.location.pathname.toString().slice(12).replace(/^\/|\/$/g, '');

        if (window.__PRELOADED_STATE__.pages[index_video]) {
            //return window.__PRELOADED_STATE__.pages[index_video] // props.match.params.slug.toString().replace(/\/$/, '')
            if (slug_media) {
                return slug_media
            } else {
                pushHistoryWithErrorNotFound(props.history)
            }
        } else {
            pushHistoryWithErrorNotFound(props.history)
        }
    }


    renderTitle() {
        if (this.props.isError) {
            return null
        }

        return (<>
            <TitleMajor>{this.props.data.title}</TitleMajor>
            <div className={styles['b-statistic']}>
                <span data-timestamp="1764681074.0" className={styles['b-statistic_time']}>{formatShortDate(this.props.data.publishedAt)}</span>
                <a href={urls.media} className={styles['b-statistic_category']}>Видео</a>
            </div>
        </>)
    }

    renderContent() {
        if (this.props.isError) {
            return (
                <Error>{COMMON_ERROR}</Error>
            )
        }

        return (
            <div className={styles.inner}>
                <Content>
                    {/* <div dangerouslySetInnerHTML={{ __html: this.props.data.content }} /> */}
                    <ReactPlayer 
                        //slot="media" 
                        src={this.props.data.videoUrl} 
                        controls={true} 
                        autoPlay={false}
                        //preload={false}
                        config={{ youtube: { playerVars: { cc_load_policy: 0 } }}}
                        style={{width: `100%`, height: `100%`, maxWidth: "1328px", margin: "auto", aspectRatio: '16/9'}}
                    />
                </Content>
            </div>
        )
    }

    render() {
        if (!this.props.isFetched || this.props.isFetching) {
            return null
        }

        return (
            <Main>
                <div className={styles.base}>
                    <div className={styles.head}>
                        <Back caption={TO_LANDING} to={urls.landing} location={this.props.location} />
                        {this.renderTitle()}
                    </div>
                    <div className={styles.body}>
                        {this.renderContent()}
                    </div>
                </div>
            </Main>
        )
    }
}

export default MediaPage
//export default injectIntl(MediaPage)